import { BACKEND_URL } from "../api/config";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import {
  FiArrowRight,
  FiCheck,
  FiEye,
  FiEyeOff,
  FiLock,
  FiShield,
  FiUser,
} from "react-icons/fi";
import "../styles/auth/login.css";
import logo from "../assets/images/logo.png";

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token")) navigate("/dashboard");
  }, [navigate]);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/auth/token/`,
        formData
      );
      localStorage.setItem("token", response.data.access);
      localStorage.setItem("refresh_token", response.data.refresh);
      localStorage.setItem("access_policy", JSON.stringify(response.data.permissions || {}));
      localStorage.setItem("current_user", JSON.stringify({
        id: response.data.id, username: response.data.username, role: response.data.role,
        role_tag: response.data.role_tag, permissions: response.data.permissions || {},
        access_roles: response.data.access_roles || [],
      }));
      onLogin?.();
      navigate("/dashboard");
    } catch {
      Swal.fire({
        title: "Login Failed",
        text: "Invalid username or password.",
        icon: "error",
        confirmButtonColor: "#a92f6f",
        customClass: { popup: "login-alert" },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-shell" aria-label="Tukuza Management System login">
        <aside className="login-story">
          <div className="story-orbit story-orbit--one" aria-hidden="true" />
          <div className="story-orbit story-orbit--two" aria-hidden="true" />
          <div className="story-leaf" aria-hidden="true"><i /><i /><i /><i /></div>

          <header className="story-brand">
            <span className="story-logo"><img src={logo} alt="" /></span>
            <span><strong>TMS</strong><small>Tukuza Management System</small></span>
          </header>

          <div className="story-copy">
            <span className="story-kicker"><i /> A better way to work</span>
            <h1>Where People <em>&amp; Quality</em> Count.</h1>
            <p>Where People &amp; Quality Count.</p>
          </div>

          <div className="story-values">
            {["Continuous Improvement", "6S Excellence", "Process Excellence"].map((item) => (
              <span key={item}><FiCheck />{item}</span>
            ))}
          </div>

          <footer className="story-footer">
            <span>Rift Valley Roses Ltd.</span>
            <span>© {new Date().getFullYear()} RVR</span>
          </footer>
        </aside>

        <section className="login-access">
          <div className="mobile-botanical" aria-hidden="true"><i /><i /><i /><span /></div>
          <div className="access-mobile-brand">
            <span><img src={logo} alt="Tukuza logo" /></span>
            <div><strong>Tukuza Management System</strong><small>Where People &amp; Quality Count</small></div>
          </div>

          <div className="access-card">
            <div className="access-status"><span><i /> System Online · Secure Portal</span><FiShield /></div>
            <div className="access-heading">
              <span>Sign in to your account</span>
              <h2>Welcome back.</h2>
            </div>

            <form className="login-form" onSubmit={handleSubmit}>
              <label className="login-field">
                <span>Username</span>
                <div><FiUser /><input name="username" value={formData.username} onChange={handleChange} placeholder="Enter your username" autoComplete="username" required autoFocus /></div>
              </label>

              <label className="login-field">
                <span>Password</span>
                <div><FiLock /><input name="password" type={showPassword ? "text" : "password"} value={formData.password} onChange={handleChange} placeholder="Enter your password" autoComplete="current-password" required /><button type="button" onClick={() => setShowPassword((value) => !value)} aria-label={showPassword ? "Hide password" : "Show password"}>{showPassword ? <FiEyeOff /> : <FiEye />}</button></div>
              </label>

              <button className="login-submit" type="submit" disabled={loading}>
                <span>{loading ? "Authenticating…" : "Sign In"}</span>
                {loading ? <i className="login-spinner" /> : <FiArrowRight />}
              </button>
            </form>

            <p className="access-help">Access is restricted to authorized personnel. <strong>Contact your administrator</strong> to request credentials.</p>
          </div>

          <footer className="access-footer">© {new Date().getFullYear()} Rift Valley Roses Ltd. All rights reserved.</footer>
        </section>
      </section>
    </main>
  );
};

export default Login;
